import {
    CREATE_CLIP_REQUEST_GET_REQUEST,
    CREATE_CLIP_REQUEST_GET_RESULT,
    CREATE_CLIP_REQUEST_OPEN_MODAL,
    CREATE_CLIP_REQUEST_REQUEST,
    CREATE_CLIP_REQUEST_RESULT,
    CLEAR_REDUX,
} from 'Redux/actionTypes';

const INIT_STATE = {
    loading: false,
    openModal: false,
    clipRequest: false,
    current: null
};

export default (state = INIT_STATE, action) => {

    switch (action.type) {
        case CREATE_CLIP_REQUEST_GET_REQUEST:
            return { ...state, loading: true }

        case CREATE_CLIP_REQUEST_GET_RESULT:
            return { ...state, loading: false }

        case CREATE_CLIP_REQUEST_OPEN_MODAL:
            return { ...state, openModal: true, current: action.payload }

        case CREATE_CLIP_REQUEST_REQUEST:
            return { ...state, loading: true }

        case CREATE_CLIP_REQUEST_RESULT:
            return { ...state, loading: false, result: action.payload }

        case CLEAR_REDUX:
            return ["", "CREATE_CLIP_REQUEST"].includes(action.payload.option)
                ? action.payload.parameters ? { ...state, ...action.payload.parameters } : { ...INIT_STATE }
                : { ...state }
        default:
            return state;
    }
};